(function () {
  if (document.documentElement.dataset.guaranaPdp === '1') return;
  document.documentElement.dataset.guaranaPdp = '1';

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      var wrap = details.closest('.guarana-pdp-accordion');
      if (!wrap) return;
      wrap.querySelectorAll('details').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    },
    true
  );

  function dialogFromTrigger(trigger) {
    var root = trigger.closest('.guarana-tabela-de-medidas');
    if (!root) return null;
    return root.querySelector('dialog.guarana-tabela-de-medidas__dialog');
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-size-chart-open]');
    if (openBtn) {
      var dialog = dialogFromTrigger(openBtn);
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      }
      return;
    }

    var closeBtn = event.target.closest('[data-size-chart-close]');
    if (closeBtn) {
      var openDialog = closeBtn.closest('dialog');
      if (openDialog && typeof openDialog.close === 'function') openDialog.close();
      return;
    }

    if (event.target && event.target.tagName === 'DIALOG' && event.target.classList.contains('guarana-tabela-de-medidas__dialog')) {
      event.target.close();
    }
  });
})();
